import { Users } from 'lucide-react';
import type { AdminCompanyMembers } from 'app/javascript/types/admin';
import HealthPanel from 'app/javascript/components/admin/company_health/HealthPanel';
import HealthRow from 'app/javascript/components/admin/company_health/HealthRow';
import { Progress } from 'app/javascript/components/ui/progress';
import { Separator } from 'app/javascript/components/ui/separator';
import { cn } from 'app/javascript/lib/utils';

export default function MembersPanel({ members }: { members: AdminCompanyMembers }) {
  // Facial coverage is the number this panel exists for: below half, facial
  // check-in does not work for the academy no matter what else is green.
  const coverage = members.total > 0 ? Math.round((members.with_face / members.total) * 100) : 0;
  const healthy = coverage >= 50;

  return (
    <HealthPanel
      icon={<Users className="size-4" />}
      title="Membros"
      action={<span className="text-xs text-muted-foreground">{members.total} ativos</span>}
    >
      <div className="space-y-1.5 py-1.5">
        <div className="flex items-baseline justify-between gap-4">
          <span className="text-xs text-muted-foreground">Cobertura facial</span>
          <span className="text-sm font-medium tabular-nums">
            {coverage}%
            <span className="text-muted-foreground">
              {' '}
              · {members.with_face} de {members.total}
            </span>
          </span>
        </div>
        {/* Neutral track in every state — a coloured empty track reads as full. */}
        <Progress
          value={coverage}
          aria-label={`Cobertura facial: ${coverage}%`}
          className={cn(
            'bg-secondary',
            !healthy && '[&>[data-slot=progress-indicator]]:bg-amber-500'
          )}
        />
      </div>
      <Separator className="my-3" />
      <HealthRow label="Sem facial" value={members.without_face.toLocaleString('pt-BR')} />
      <HealthRow label="Aguardando aprovação" value={members.pending.toLocaleString('pt-BR')} />
      <HealthRow label="Donos e admins" value={members.managers.toLocaleString('pt-BR')} />
      <HealthRow label="Contas apagadas (LGPD)" value={members.erased.toLocaleString('pt-BR')} />
    </HealthPanel>
  );
}
